import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { AuthPromptService } from './auth-prompt.service';

/**
 * Requires sign-in. Guests are sent to /login with returnUrl
 * so they land back on the protected page after success.
 */
export const authGuard: CanActivateFn = (_, state) => {
  const auth = inject(AuthService);
  if (auth.currentUser()) {
    return true;
  }

  const target = state.url;
  inject(AuthPromptService).storeReturnUrl(target);

  return inject(Router).createUrlTree(['/login'], {
    queryParams:
      target && target !== '/login' && target !== '/register' ? { returnUrl: target } : undefined
  });
};
